import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'
import productLabels from 'i18n/productLabels'
import formatStaticAppText from 'lib/format/formatStaticAppText'
import FooterList from './FooterList'
import FooterListItem from './FooterListItem'

type InheritedFooterListProps = Pick<ComponentProps<typeof FooterList>, 'title'>

interface Props extends InheritedFooterListProps {
  title: string
  items: Array<App.PageConfig>
}

function FooterItemList({ title, items }: Props) {
  const intl = useIntl()
  const localizedLinkText = (raw: string) => {
    const descriptor = Object.values(productLabels).find(d => d.defaultMessage === raw)
    return descriptor ? intl.formatMessage(descriptor) : formatStaticAppText(intl, raw)
  }
  return <FooterList title={title}>
    {items.map((item) => {
      const text = typeof item.text === 'string'
        ? localizedLinkText(item.text)
        : intl.formatMessage(item.text)
      return <FooterListItem
        key={item.type}
        title={text}
        to={item.url?.to}
        href={item.url?.href}
        target={item.url?.target}
      />
    })}
  </FooterList>
}

export default FooterItemList
